module.exports = __webpack_public_path__ + "img/help-enter.69f99d8a.png";